import { Spin } from 'antd';
import BusinessIcon from 'app/components/Sidebar/icons/BusinessIcon';
import styled from 'styled-components';

export const UserDetailsWrapper = styled.div`
  background: ${p => p.theme.backgroundColor};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DetailsWrapper = styled.div`
  padding: 24px;
`;

export const Spinner = styled(Spin)`
  margin: auto;
`;

export const AddCompanyToUserIcon = styled(BusinessIcon)`
  svg {
    color: #52c41a;
    width: 24px;
    height: 24px;
  }
`;
